import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26cc8698"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notifications h-full bg-primary-50" }
const _hoisted_2 = { class: "left-panel sidebar fixed overflow-hidden" }
const _hoisted_3 = { class: "w-full text-right" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full text-left" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title font-bold pb-2 pt-4" }, "Notifiche")
], -1))
const _hoisted_5 = { class: "filters sticky top-0 flex" }
const _hoisted_6 = { class: "notifications-section list h-full overflow-auto" }
const _hoisted_7 = { class: "semi-section-title text-left top-0 pt-6 pb-2 text-sm font-bold sticky bg-primary-50" }
const _hoisted_8 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationCard = _resolveComponent("NotificationCard")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["filter p-2 mr-2 font-bold text-sm rounded cursor-pointer", { 'text-primary-200': !_ctx.filteringDocumentsToBeApproved, 'bg-white': !_ctx.filteringDocumentsToBeApproved, 'text-white': _ctx.filteringDocumentsToBeApproved, 'bg-primary-600': _ctx.filteringDocumentsToBeApproved, 'focus:bg-primary-200': true, 'focus:text-white': true  }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filteringDocumentsToBeApproved = !_ctx.filteringDocumentsToBeApproved))
          }, "Documenti da approvare", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["filter p-2 mr-2 font-bold text-sm rounded cursor-pointer", { 'text-primary-200': !_ctx.filteringWorkingSiteUpdates, 'bg-white': !_ctx.filteringWorkingSiteUpdates, 'text-white': _ctx.filteringWorkingSiteUpdates, 'bg-primary-600': _ctx.filteringWorkingSiteUpdates, 'focus:bg-primary-200': true, 'focus:text-white': true  }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filteringWorkingSiteUpdates = !_ctx.filteringWorkingSiteUpdates))
          }, "Aggiornamenti cantiere", 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationsGrouped, (v, k) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.groupTitle(k)), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v, (notification) => {
              return (_openBlock(), _createBlock(_component_NotificationCard, { "model-value": notification }, null, 8, ["model-value"]))
            }), 256))
          ], 64))
        }), 256)),
        _createElementVNode("div", {
          class: "paginate text-center text-xs text-primary-800 font-bold cursor-pointer",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onPaginate && _ctx.onPaginate(...args)))
        }, "Carica altre notifiche")
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "slide-fade",
            mode: "in-out"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          message: "Caricamento..."
        }))
      : _createCommentVNode("", true)
  ]))
}